import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/account-details/manage/page.tsx")